module.exports = __webpack_public_path__ + "static/media/shopping.eb3f7b3f.png";